import React from 'react';
import { withTranslation } from 'react-i18next'
import {
    Modal,
    Tab,
    Tabs,
    TabContent,
    TabScrollButton,
    TabList,
    Paper as MuiPaper,
    AppBar,
    Toolbar,
    Typography as MuiTypography,
    Grid as MuiGrid,
    FormGroup,
    FormControl as MuiFormControl,
    FormControlLabel,
    FormLabel,
    FormHelperText,
    Input,
    InputLabel,
    Select,
    TextField,
    MenuItem,
    Button,
    Switch,
    Radio,
    RadioGroup,
    Divider,
    InputAdornment,
    Box as MuiBox,
} from '@material-ui/core';
import { DropzoneDialog } from 'material-ui-dropzone'
import _, { debounce } from 'lodash';
import {
    KeyboardDatePicker
} from "@material-ui/pickers";
import { connect } from 'react-redux';
import CloseIcon from "@material-ui/icons/Close";
import { TPLoader } from '../../../components/Progress';
import GoogleMapReact from 'google-map-react'
import { GMapAPIKey } from '../../../../env'
import { popAlert } from '../../../../redux/actions/sessionActions';
import {
    getSupportedCountries,
    getEquipment,
    getValidUnits
} from '../../../../redux/actions/adminActions';
import { getCompanyVehicles } from '../../../../redux/actions/vehicleActions';
import { 
    createVehicle, 
    editVehicle, 
    createLegalDoc,
    getMakes,
    getModels,
    getYears
} from '../../../../redux/util/vehicleAPI';
import { spacing } from "@material-ui/system";
import styled from "styled-components";
import NotificationSnackbar from '../../Util/Snackbar';
import { Autocomplete } from "@material-ui/lab";
import { convertWeight, parseError } from '../../../../redux/reducers/helpersReducerr';

const Paper = styled(MuiPaper)(spacing);
const Typography = styled(MuiTypography)(spacing);
const FormControl = styled(MuiFormControl)(spacing);
const Grid = styled(MuiGrid)(spacing);
const Box = styled(MuiBox)(spacing);
const Bold = styled.span`
  font-weight: ${props => props.theme.typography.fontWeightMedium};
  color: black;
`;

const GoogleMapReactWrapper = styled.div`
  height: 300px;
  width: 100%;
`;
function SectionHeader({ title }) {
    return (<>
        <Typography variant="h2" mb={4}><Bold>{title}</Bold></Typography>
        <Divider />
    </>
    )
}

/**
 * 
 * @prop {Vehicle} vehicle
 * @prop {string} type - 'create' | 'edit'
 * 
 */
class CreateEditVehicleModal extends React.Component {
    nullState = {
        name: "",
        type_id: "",
        vehicleFile: "",

        license_plate: "",
        license_plate_country_id: "",
        license_plate_2: "",
        license_plate_2_country_id: "",
        trailer_id_1: "",
        trailer_id_2: "",

        vin: "",
        fuel_usage: "",
        tank_size: "",
        tank_units: "",
        number_of_axles: "",
        
        truck_tare_weight: "",
        truck_tare_weight_units: "",
        tare_weight_expires_at: new Date(),
        weight_capacity: "",
        weight_capacity_units: "",
        volume_capacity: "",
        volume_capacity_units: "",

        insuranceExpirationDate: new Date(),
        insuranceFile: "",
      
        loading: true,
        open: false,
        openInsurance: false,
        hasSecondaryLicense: false,
        hasVIN: true,

        loadingMakes: false,
        searchMakes: "",
        makes: [],
        make: "",

        loadingModels: false,
        searchModels: "",
        models: [],
        model: "",

        loadingYears: false,
        searchYear: "",
        years: [],
        year: "",

        // Used for tabs,
        currentTab: "manual", // "manual" | "upload"
        
    }
    constructor(props) {
        super(props);
        this.today = new Date();
        this.state = { 
            ...this.nullState,
            tank_units: props.defaults.default_volume_unit || "",
            truck_tare_weight_units: props.defaults.default_weight_unit || "",
            weight_capacity_units: props.defaults.default_weight_unit || "",
            volume_capacity_units: props.defaults.default_vehicle_volume_capacity_units || "",
        }
        this.addressInput = React.createRef();
    }

    prefillState = async () => {
        if (this.props.vehicle) {
            console.log("vehicle", this.props.vehicle)
            const vehicle = this.props.vehicle
            const prefilledState = { ...this.nullState }
            Object.keys(vehicle).forEach(vehicleKey => {
                if (prefilledState.hasOwnProperty(vehicleKey) && vehicle[vehicleKey]) {
                    prefilledState[vehicleKey] = vehicle[vehicleKey];
                }
            })
            
            // vehicle properties that can't be set programatically
            const override = {
               type_id: vehicle.equipment_type.id,
               hasVIN: !!vehicle.vin,
               hasSecondaryLicense: Boolean(vehicle.license_plate_2 && vehicle.license_plate_2_country_id),
               searchMakes: vehicle.make || "",
               searchModels: vehicle.model || "",
               searchYear: vehicle.year || "",
            }

            let finalState = {
                ...prefilledState,
                ...override,
            }
            if (!vehicle.vin) {
                const vehicleInfo = await this.prefillVehicleInfo()
                finalState = {
                    ...finalState, 
                    ...vehicleInfo,
                }
            }
            console.log("final", finalState)
            this.setStateIfMounted({
                ...finalState,
                loading: false,
            }) 
        } else {
            this.setState({
                ...this.nullState,
                loading: false,
            })
        }
    }
    componentDidMount = () => {
        this.mounted = true;
        Promise.all([
            this.props.getSupportedCountries(),
            this.props.getEquipment(this.props.token),
            this.props.getValidUnits(this.props.token)
        ])
        .then(resArray => {
            // const newState = {
            //     equipmentTypes: [],
            // }
            if (this.props.type == 'edit') {
                this.prefillState()
            } else {
                this.setStateIfMounted({ 
                    // ...newState, 
                    loading: false 
                })

            }
        })
    }
    /**
     * Usually, the makes/model/years are fetched as the query changes, and they are filled out in the respective order.
     * When this component is used for edit, the make/model/year search text is prefilled, but the underlying values are not fetched/selected.
     * This will fetch the make/model/year and select the values
     * @returns {{ make: {}, makes: [], model: {}, models: [], years: [], year: "" }} info for the initial state
     */
    prefillVehicleInfo = async () => {
        console.log("prefilling info")
        const {
            vehicle,
            token,
        } = this.props

        // No need to get manual input vehicle info if the vehicle was made using a VIN
        if (!vehicle || vehicle.vin) return;
        console.log("starting prefilling info")
        try {
            // Get make
            const makesPage = await getMakes(token, vehicle.make)
            if (!makesPage.success) throw new Error("Makes not found")
            const makes = makesPage.data.data
            const make = makes.find(make => make.name === vehicle.make)

            // Discontinue if we can't find a matching make in DB
            if (!make) throw new Error("Make not found")

            // Get model
            const modelsPage = await getModels(token, make.id, vehicle.model)
            if (!modelsPage.success) throw new Error("Models not found")
            const models = modelsPage.data.data
            const model = models.find(model => model.name === vehicle.model)

            // Discontinue if we can't find a matching model in DB
            if (!model) throw new Error("Model not found") 

            // Get years
            const years = await getYears(token, model.id)
            if (!years.success) throw new Error("Years not found")
            console.log("prefilling info done")
            return {
                makes,
                make,
                models,
                model,
                years: years.data,
            }
        } catch (e) {
            console.log("error prefillVehicleInfo", e)
            return {
                makes: [],
                make: "",
                models: [],
                model: "",
                years: [],
            }
        }
    }
    componentWillUnmount = () => {
        this.mounted = false;
    }
    componentDidUpdate = (prevProps, prevState) => {
        // `!prev.state.loading` was added to prevent state clearing when initially prefilling values
        if (prevState.searchMakes != this.state.searchMakes && this.state.searchMakes && !prevState.loading) {
            console.log("clearing makes")
            this.setStateIfMounted({ model: "", models: [], year: "", years: [] })
            this.getMakesDebounced();
        }
        // `!prev.state.loading` was added to prevent state clearing when initially prefilling values
        if (prevState.searchModels != this.state.searchModels && this.state.make && this.state.make.id && this.state.searchModels && !prevState.loading) {
            console.log("clearing years")
            this.setStateIfMounted({ year: "", years: [] })
            this.getModelsDebounced();
        }
        if (prevState.model != this.state.model && this.state.model && this.state.model.id) {
            this.getYears()
        }
    }
    setStateIfMounted = (state, callback) => {
        if (this.mounted) {
            this.setState(state, callback)
        }
    }
    handleChange = (field, type) => {
        if (type) {
            if (type == 'boolean') {
                return event => this.setStateIfMounted({ [field]: event.target.checked })
            } else if (type == 'number') {
                return event => this.setStateIfMounted({ [field]: parseFloat(event.target.value) || "" })
            } else if (type == 'date') {
                return date => this.setStateIfMounted({ [field]: date })
            } else if (type == 'time') {
                return time => this.setStateIfMounted({ [field]: time })
            } else if (type == 'radio-boolean') {
                return event => this.setStateIfMounted({ [field]: event.target.value == 'true' ? true : false })
            }
        }
        return event => this.setStateIfMounted({ [field]: event.target.value });
    }
    getMakes = () => {
        getMakes(this.props.token, this.state.searchMakes).then(res => {
            if (res.success) {
                this.setStateIfMounted({ 
                    makes: res.data.data,
                    loadingMakes: false,
                })
            }
        })
    }
    getMakesDebounced = debounce(this.getMakes, 500, { maxWait: 1000, leading: false, trailing: true });
    getModels = () => {
        getModels(this.props.token, this.state.make.id, this.state.searchModels).then(res => {
            if (res.success) {
                this.setStateIfMounted({ 
                    models: res.data.data,
                    loadingModels: false,
                })
            }
        })
    }
    getModelsDebounced = debounce(this.getModels, 500, { maxWait: 1000, leading: false, trailing: true });
    getYears = () => {
        getYears(this.props.token, this.state.model.id).then(res => {
            if (res.success) {
                this.setStateIfMounted({ years: res.data })
            }
        })
    }

    handleRatingChange = newRating => {
        this.setStateIfMounted({
            internet_quality: newRating
        })
    }
    handleFileChange = field => files => {
        this.setStateIfMounted({
            [field]: files[0],
            open: false,
            openInsurance: false
        })
    }
    getFillerInsurancePhoto = async () => {
        const imageURL = "data:image/png;base64,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"
        const file = await fetch(imageURL).then(res => res.blob()).then(blob => new File([blob], "insurance.png", { type: "image/png" }))
        return file;
    }
    verifyWeightCapacity = () => {
        try {
            const numTare = parseFloat(this.state.truck_tare_weight)
            const numWeightCap = parseFloat(this.state.weight_capacity)
            const convertedNumWeightCap = convertWeight(numWeightCap, this.state.weight_capacity_units, this.state.truck_tare_weight_units)
    
            return numTare < convertedNumWeightCap
        } catch (e) {
            return false
        }
    }

    organizeVehiclePostData = async () => {

        if (!this.verifyWeightCapacity()) {
            this.props.popAlert('error', this.props.t('error'), "The weight capacity must be larger than the tare weight");
            return
        }

        const postData = {
            name: "",
            type_id: "",
            vehicleFile: "",

            license_plate: "",
            license_plate_country_id: "",
            // license_plate_2: "",
            // license_plate_2_country_id: "",
            trailer_id_1: "",
            trailer_id_2: "",

            fuel_usage: "",
            tank_size: "",
            tank_units: "",
            number_of_axles: "",

            truck_tare_weight: "",
            truck_tare_weight_units: "",
            weight_capacity: "",
            weight_capacity_units: "",
            volume_capacity: "",
            volume_capacity_units: "",
        }
        if (this.state.hasVIN) {
            postData.vin = ""
        } else {
            postData.make = "";
            postData.model = "";
            postData.year = "";
        }
        const formData = new FormData();
        const editPostData = {}

        Object.keys(postData).forEach(key => {
            if (this.state.hasOwnProperty(key)) {
                if (_.isObject(this.state[key]) || Boolean(this.state[key])) {
                    if (typeof this.state[key] == 'object') {
                        // for no vin, makes and models
                        console.log('for no vin', key, this.state[key])
                        formData.append(`data[${key}]`, this.state[key].name)
                        editPostData[key] = this.state[key].name
                    } else {
                        formData.append(`data[${key}]`, this.state[key])
                        editPostData[key] = this.state[key]
                    }
                }
            }
        })
        if (this.state.tare_weight_expires_at) {
            const expiresAt = this.props.helpers.makeUnixTime(this.state.tare_weight_expires_at)
            formData.append('data[tare_weight_expires_at]', expiresAt)
            editPostData.tare_weight_expires_at = expiresAt
        }
        if (this.state.vehicleFile) {
            formData.append('media[image]', this.state.vehicleFile)
        }

        if (this.state.hasSecondaryLicense) {
            formData.append('data[license_plate_2]', this.state.license_plate_2)
            formData.append('data[license_plate_2_country_id]', this.state.license_plate_2_country_id)
            editPostData.license_plate_2 = this.state.license_plate_2
            editPostData.license_plate_2_country_id = this.state.license_plate_2_country_id
        } else if (this.props.type === "edit") {
            editPostData.license_plate_2 = null
            editPostData.license_plate_2_country_id = null
        }

        

        const postType = this.props.type;
        if (postType == 'create') {
            createVehicle(this.props.token, this.props.company.id, formData).then(res => {
                if (res.success) {
                    this.props.popAlert('success', this.props.t('success'), this.props.t('vehicleTranslations.success.createVehicle'))
                    if ((this.state.insuranceExpirationDate && this.state.insuranceFile) || this.props.company.isForeign) {
                        this.uploadInsurance(res.data.new_vehicle_ids[0])
                    } else {
                        this.props.getCompanyVehicles(this.props.token, this.props.company.id)
                        this.props.setModalOpen(false)
                    }

                } else {
                    this.setStateIfMounted({
                        loading: false,
                    }, () => this.props.popAlert('error', this.props.t('error'), parseError(res)))
                }
            })
        } else if (postType == 'edit') {
            console.log('edit post data', editPostData)
            editVehicle(this.props.token, this.props.company.id, this.props.vehicle.id, editPostData).then(res => {
                if (res.success) {
                    this.props.popAlert('success', this.props.t('success'), this.props.t('vehicleTranslations.success.editVehicle'))
                    this.props.getCompanyVehicles(this.props.token, this.props.company.id)
                    this.props.setModalOpen(false)
                } else {
                    this.setStateIfMounted({
                        loading: false,
                    }, () => this.props.popAlert('error', this.props.t('error'), parseError(res)))
                }
            })
        }

    }
    uploadInsurance = async (vehicleID) => {
        const formData = new FormData();

        if (this.props.company.isForeign) {
            const expDate = new Date('2038')
            const fillerPhoto = await this.getFillerInsurancePhoto();
            formData.append('data[image]', fillerPhoto);
            formData.append('data[vehicle_id]', vehicleID);
            formData.append('data[legal_document_type_id]', 1);
            formData.append('data[expiration_date]', this.props.helpers.makeUnixTime(expDate));
        } else {
            formData.append('data[image]', this.state.insuranceFile);
            formData.append('data[vehicle_id]', vehicleID);
            formData.append('data[legal_document_type_id]', 1);
            formData.append('data[expiration_date]', this.props.helpers.makeUnixTime(this.state.insuranceExpirationDate));
        }

        createLegalDoc(this.props.token, this.props.company.id, formData).then(res => {
            if (res.success) {
                this.props.popAlert('success', 'Success', 'Insurance processed!')
                this.props.getCompanyVehicles(this.props.token, this.props.company.id)
            } 
            this.props.setModalOpen(false)
        })
    }
    submitSite = event => {
        event.preventDefault();
        console.log("submitting!")
        this.props.popAlert('info', this.props.t('loading'), this.props.t('vehicleTranslations.loading.processVehicle'))
        this.organizeVehiclePostData()
    }
    render = () => {
        return (
            <form autoComplete="off" onSubmit={(event) => this.submitSite(event)}>
                {this.props.type == 'create' && <Grid container spacing={10}>
                    <Grid item xs={12} md={(this.props.vehicle && this.props.vehicle.photo_url) ? 6 : 12}>
                        <Button variant="contained" color="primary" fullWidth type="button" onClick={() => this.setStateIfMounted({ open: !this.state.open })}>{this.props.t('vehicleTranslations.actions.uploadPhotoOptional')}</Button>
                        <DropzoneDialog
                            open={this.state.open}
                            onSave={this.handleFileChange('vehicleFile')}
                            showPreviews={true}
                            maxFileSize={2000000}
                            onClose={() => this.setStateIfMounted({ open: false })}
                            showFileNamesInPreview={true}
                            showFileNames={true}
                            filesLimit={1}
                            acceptedFiles={['image/*']}
                            dropzoneText={this.props.t('vehicleTranslations.actions.uploadPhotoOptional')}
                        />
                    </Grid>
                    {(this.props.vehicle && this.props.vehicle.photo_url) && <Grid item xs={12} md={6}>
                        <img src={this.props.vehicle.photo_url} style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                    </Grid>}
                </Grid>}
                <Grid container spacing={10}>
                    <Grid item xs={12} md>
                        <FormControl fullWidth>
                            <TextField
                                id="name"
                                label={this.props.t('vehicleTranslations.vehicleName')}
                                value={this.state.name}
                                onChange={this.handleChange("name")}
                                type="text"
                                required
                                error={!this.state.name}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="type_id">{this.props.t('vehicleTranslations.equipmentType')}</InputLabel>
                            <Select
                                labelId="type_id"
                                label={this.props.t('vehicleTranslations.equipmentType')}
                                value={this.state.type_id}
                                onChange={this.handleChange('type_id')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "type_id",
                                    id: "type_id"
                                }}
                                error={!this.state.type_id}
                            >
                                {this.props.equipmentTypes.map(type => (
                                    <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">{this.props.t('vehicleTranslations.hasVIN')}</FormLabel>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.hasVIN}
                                            onChange={this.handleChange("hasVIN", 'boolean')}
                                            color="primary"
                                        />
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
                {this.state.hasVIN && <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                id="vin"
                                label={this.props.t('vehicleTranslations.vin')}
                                value={this.state.vin}
                                onChange={this.handleChange("vin")}
                                type="text"
                                required
                                error={!this.state.vin}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>}
                {!this.state.hasVIN && <>
                    <Grid container spacing={10}>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="vehicle_make_autocomplete"
                                    disableClearable
                                    autoComplete
                                    clearOnBlur={false}
                                    options={this.state.makes}
                                    getOptionLabel={(option) => `${option.name}`}
                                    onChange={(event, val) => {
                                        this.setStateIfMounted({
                                            make: val
                                        })
                                    }}
                                    loading={this.state.loadingMakes}
                                    loadingText="Loading makes"
                                    onInputChange={(event, val, reason) => {
                                        if (reason != 'reset' || val) {
                                            this.setStateIfMounted({
                                                searchMakes: val,
                                                loadingMakes: true,
                                            })
                                        }
                                    }}
                                    inputValue={this.state.searchMakes}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            id="searchMakes"
                                            label={this.props.t('vehicleTranslations.searchMakes')}
                                            type="text"
                                            required
                                            error={!this.state.searchMakes}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        {Boolean(this.state.make) && <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="vehicle_model_autocomplete"
                                    disableClearable
                                    autoComplete
                                    clearOnBlur={false}
                                    options={this.state.models}
                                    getOptionLabel={(option) => `${option?.name || ""}`}
                                    onChange={(event, val) => {
                                        this.setStateIfMounted({
                                            model: val
                                        })
                                    }}
                                    loading={this.state.loadingModels}
                                    loadingText="Loading models"
                                    onInputChange={(event, val, reason) => {
                                        if (reason != 'reset' || val) {
                                            this.setStateIfMounted({
                                                searchModels: val,
                                                loadingModels: true,
                                            })
                                        }
                                    }}
                                    inputValue={this.state.searchModels}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            id="searchModels"
                                            label={this.props.t('vehicleTranslations.searchModels')}
                                            type="text"
                                            required
                                            error={!this.state.searchModels}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>}
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    id="vehicle_year_autocomplete"
                                    disableClearable
                                    autoComplete
                                    clearOnBlur={false}
                                    options={this.state.years}
                                    getOptionLabel={(option) => option.toString()}
                                    onChange={(event, val) => {
                                        this.setStateIfMounted({
                                            year: val
                                        })
                                    }}
                                    loading={this.state.loadingYears}
                                    loadingText="Loading models"
                                    onInputChange={(event, val, reason) => {
                                        if (reason != 'reset' || val) {
                                            this.setStateIfMounted({
                                                searchYear: val,
                                                loadingYears: true,
                                            })
                                        }
                                    }}
                                    inputValue={this.state.searchYear}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            id="searchYear"
                                            label={this.props.t('vehicleTranslations.year')}
                                            type="text"
                                            required
                                            error={!this.state.searchYear}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </>}
                <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="weight_capacity"
                                label={this.props.t('vehicleTranslations.weightCapacity')}
                                value={this.state.weight_capacity}
                                onChange={this.handleChange("weight_capacity")}
                                type="number"
                                required
                                error={!this.state.weight_capacity}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="weight_capacity_units">{this.props.t('unitTranslations.weightUnit')}</InputLabel>
                            <Select
                                labelId="weight_capacity_units"
                                label={this.props.t('unitTranslations.weightUnit')}
                                value={this.state.weight_capacity_units}
                                onChange={this.handleChange('weight_capacity_units')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "weight_capacity_units",
                                    id: "weight_capacity_units"
                                }}
                                error={!this.state.weight_capacity_units}
                            >
                                {this.props.units.weight.map(unit => (
                                    <MenuItem key={unit} value={unit}>{this.props.t(`unitTranslations.weightUnits.${unit}`)}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                
                <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="volume_capacity"
                                label={this.props.t('vehicleTranslations.volumeCapacity')}
                                value={this.state.volume_capacity}
                                onChange={this.handleChange("volume_capacity")}
                                type="number"
                                error={!this.state.volume_capacity}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="volume_capacity_units">{this.props.t('unitTranslations.volumeUnit')}</InputLabel>
                            <Select
                                labelId="volume_capacity_units"
                                label={this.props.t('unitTranslations.volumeUnit')}
                                value={this.state.volume_capacity_units}
                                onChange={this.handleChange('volume_capacity_units')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "volume_capacity_units",
                                    id: "volume_capacity_units"
                                }}
                                error={!this.state.volume_capacity_units}
                            >
                                {this.props.units.volume.map(unit => (
                                    <MenuItem key={unit} value={unit}>{this.props.t(`unitTranslations.volumeUnits.${unit}`)}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="license_plate_country_id">{this.props.t('vehicleTranslations.licensePlateCountry')}</InputLabel>
                            <Select
                                labelId="license_plate_country_id"
                                label={this.props.t('vehicleTranslations.licensePlateCountry')}
                                value={this.state.license_plate_country_id}
                                onChange={this.handleChange('license_plate_country_id')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "license_plate_country_id",
                                    id: "license_plate_country_id"
                                }}
                                error={!this.state.license_plate_country_id}
                            >
                                {this.props.supportedCountries.map(country => (
                                    <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="license_plate"
                                label={this.props.t('vehicleTranslations.licensePlate')}
                                value={this.state.license_plate}
                                onChange={this.handleChange("license_plate")}
                                type="text"
                                error={!this.state.license_plate}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">{this.props.t('vehicleTranslations.secondaryLicensePlate')}</FormLabel>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.hasSecondaryLicense}
                                            onChange={this.handleChange("hasSecondaryLicense", 'boolean')}
                                            color="primary"
                                        />
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
                {this.state.hasSecondaryLicense && <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="license_plate_2_country_id">{this.props.t('vehicleTranslations.secondaryLicensePlateCountry')}</InputLabel>
                            <Select
                                labelId="license_plate_2_country_id"
                                label={this.props.t('vehicleTranslations.secondaryLicensePlateCountry')}
                                value={this.state.license_plate_2_country_id}
                                onChange={this.handleChange('license_plate_2_country_id')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "license_plate_2_country_id",
                                    id: "license_plate_2_country_id"
                                }}
                                error={!this.state.license_plate_2_country_id}
                            >
                                {this.props.supportedCountries.map(country => (
                                    <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="license_plate_2"
                                label={this.props.t('vehicleTranslations.secondaryLicensePlate')}
                                value={this.state.license_plate_2}
                                onChange={this.handleChange("license_plate_2")}
                                type="text"
                                error={!this.state.license_plate_2}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>}
                <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="trailer_id_1"
                                label={this.props.t('vehicleTranslations.trailerID1')}
                                value={this.state.trailer_id_1}
                                onChange={this.handleChange("trailer_id_1")}
                                type="text"
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="trailer_id_2"
                                label={this.props.t('vehicleTranslations.trailerID2')}
                                value={this.state.trailer_id_2}
                                onChange={this.handleChange("trailer_id_2")}
                                type="text"
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="fuel_usage"
                                label={this.props.t('vehicleTranslations.fuelUsageMPG')}
                                value={this.state.fuel_usage}
                                onChange={this.handleChange("fuel_usage")}
                                type="number"
                                required
                                error={!this.state.fuel_usage}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="number_of_axles"
                                label={this.props.t('vehicleTranslations.numberOfAxles')}
                                value={this.state.number_of_axles}
                                onChange={this.handleChange("number_of_axles")}
                                type="number"
                                required
                                error={!this.state.number_of_axles}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                id="tank_size"
                                label={this.props.t('vehicleTranslations.tankSize')}
                                value={this.state.tank_size}
                                onChange={this.handleChange("tank_size")}
                                type="number"
                                required
                                error={!this.state.tank_size}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="tank_units">{this.props.t('unitTranslations.volumeUnit')}</InputLabel>
                            <Select
                                labelId="tank_units"
                                label={this.props.t('unitTranslations.volumeUnit')}
                                value={this.state.tank_units}
                                onChange={this.handleChange('tank_units')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "tank_units",
                                    id: "tank_units"
                                }}
                                error={!this.state.tank_units}
                            >
                                {this.props.units.volume.map(unit => (
                                    <MenuItem key={unit} value={unit}>{this.props.t(`unitTranslations.volumeUnits.${unit}`)}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <TextField
                                id="truck_tare_weight"
                                label={this.props.t('vehicleTranslations.tareWeight')}
                                value={this.state.truck_tare_weight}
                                onChange={this.handleChange("truck_tare_weight")}
                                type="number"
                                required
                                error={!this.state.truck_tare_weight}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="truck_tare_weight_units">{this.props.t('unitTranslations.weightUnit')}</InputLabel>
                            <Select
                                labelId="truck_tare_weight_units"
                                label={this.props.t('unitTranslations.weightUnit')}
                                value={this.state.truck_tare_weight_units}
                                onChange={this.handleChange('truck_tare_weight_units')}
                                fullWidth
                                required
                                inputProps={{
                                    name: "truck_tare_weight_units",
                                    id: "truck_tare_weight_units"
                                }}
                                error={!this.state.truck_tare_weight_units}
                            >
                                {this.props.units.weight.map(unit => (
                                    <MenuItem key={unit} value={unit}>{this.props.t(`unitTranslations.weightUnits.${unit}`)}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <KeyboardDatePicker
                                label={this.props.t('vehicleTranslations.tareWeightExpDate')}
                                value={this.state.tare_weight_expires_at}
                                onChange={this.handleChange('tare_weight_expires_at', 'date')}
                                format="MM/dd/yyyy"
                                min={this.today}
                                inputVariant="outlined"
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                {(!this.props.company.isForeign && this.props.type != 'edit') && <Grid container spacing={10}>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <KeyboardDatePicker
                                label={this.props.t('vehicleTranslations.insuranceExpDate')}
                                value={this.state.insuranceExpirationDate}
                                onChange={this.handleChange('insuranceExpirationDate', 'date')}
                                format="MM/dd/yyyy"
                                min={this.today}
                                inputVariant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button variant="contained" color="primary" fullWidth type="button" onClick={() => this.setStateIfMounted({ openInsurance: !this.state.openInsurance })}>{this.props.t('vehicleTranslations.actions.uploadVehicleInsurance')}</Button>
                        <DropzoneDialog
                            open={this.state.openInsurance}
                            onSave={this.handleFileChange('insuranceFile')}
                            showPreviews={true}
                            maxFileSize={2000000}
                            onClose={() => this.setStateIfMounted({ openInsurance: false })}
                            howFileNamesInPreview={true}
                            showFileNames={true}
                            filesLimit={1}
                            // acceptedFiles={['image/*']}
                            dropzoneText={"Add a picture of the vehicle insurance"}
                        />
                    </Grid>
                </Grid>}
                <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" fullWidth type="submit">
                            {this.props.type == 'create' && <Typography>{this.props.t('vehicleTranslations.actions.createVehicle')}</Typography>}
                            {this.props.type == 'edit' && <Typography>{this.props.t('vehicleTranslations.actions.editVehicle')}</Typography>}
                        </Button>
                    </Grid>
                </Grid>
            </form>

        )
    }
}
const msp = state => ({
    helpers: state.helpers,
    token: state.session.user.token,
    userID: state.session.user.id,
    defaults: state.session.user.settings,
    company: state.session.company,
    supportedCountries: state.entities.supportedCountries,
    units: state.entities.units,
    equipmentTypes: state.entities.equipment,
})
const mdp = dispatch => ({
    getSupportedCountries: () => dispatch(getSupportedCountries()),
    getCompanyVehicles: (token, companyID) => dispatch(getCompanyVehicles(token, companyID)),
    getEquipment: (token) => dispatch(getEquipment(token)),
    getValidUnits: (token) => dispatch(getValidUnits(token)),
    popAlert: (success, title, message) => dispatch(popAlert(success, title, message)),
})
export default connect(msp, mdp)(withTranslation()(CreateEditVehicleModal))